import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-master-card-display',
  templateUrl: './master-card-display.component.html',
  styleUrls: ['./master-card-display.component.scss']
})
export class MasterCardDisplayComponent {
  @Input() cardNumber: string = 'XXXX XXXX XXXX XXXX'
  @Input() expirationDate: string = 'MM/YY'
  @Input() cardName: string = 'NOMBRE Y APELLIDO'
  @Input() cvv: string = 'XXX'
}
